// extracted by mini-css-extract-plugin
module.exports = {"ranking":"ranking_ranking__2Jyum"};